<template>
  <div>
    <NewProvider @created="handleSuccessProvider" />
    <NewClient @create="handleSuccessClient" />

    <b-modal
      :size="
        idCreate == 'finance_configuration_category' ||
        idCreate == 'finance_configuration_account'
          ? 'lg'
          : 'md'
      "
      no-close-on-backdrop
      hide-footer
      id="idCreate"
      :title="titleModalIdCreate"
    >
      <NewAccount
        v-if="idCreate == 'finance_configuration_account'"
        :banks="banks"
        @success="handleSuccessAccount"
      />
      <NewCatgegory
        v-if="idCreate == 'finance_configuration_category'"
        @success="handleSuccessCategory"
      />
      <NewProfitCostCenter
        v-if="idCreate == 'finance_configuration_profit_cost_center'"
        @success="handleSuccessProfitCostCenter"
      />
      <ModalIdCreate
        v-if="
          idCreate != 'finance_configuration_account' &&
          idCreate != 'finance_configuration_category' &&
          idCreate != 'finance_configuration_profit_cost_center'
        "
        :id="idCreate"
        @success="handleSuccessIdCreate"
        @cancel="$bvModal.hide('idCreate')"
      />
    </b-modal>

    <div>
      <div class="text-center">
        <h3
          v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'"
          class="title-pages color-red m-0"
        >
          LANÇAR DÉBITO
        </h3>

        <h3
          v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
          class="title-pages color-green m-0"
        >
          LANÇAR CRÉDITO
        </h3>
      </div>

      <div
        class="content-card row m-0"
        v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
      >
        <div class="col-md-4 pt-0 pb-0 d-flex align-items-center">
          <div class="pl-5">
            <input
              class="form-check-input"
              type="checkbox"
              id="enable_resident"
              v-model="enable_resident"
              @change="handleChangeEnableResident($event.target.checked)"
            />
            <label class="form-check-label" for="enable_resident"
              >LANÇAR FATURAMENTO</label
            >
          </div>
        </div>
        <div class="col-md-8 pt-0 pb-0" v-if="enable_resident">
          <vs-select
            autocomplete
            style="width: 100%"
            v-model="finance_client_id"
            @change="handleChangeResidentId"
          >
            <vs-select-item :value="null" text="SELECIONE O RESIDENTE..." />
            <vs-select-item
              v-for="client in residents"
              :key="client.id"
              :value="client.id"
              :text="client.name"
            />
          </vs-select>
        </div>
      </div>

      <!-- 1 -->
      <div class="content-card row m-0">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center"
        >
          <label
            v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'"
            class="upper-text"
            >É um gasto:</label
          >
          <label
            v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
            class="upper-text"
            >É um ganho:</label
          >
        </div>
        <div
          class="col-xl-3 col-lg-3 col-md-10 col-sm-9 col-12 d-flex align-items-center"
        >
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="paid"
              value="paid"
            />
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'"
              class="form-check-label upper-text"
              for="paid"
              >pago</label
            >
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
              class="form-check-label upper-text"
              for="paid"
              >recebido</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="not_paid"
              value="not_paid"
            />
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'"
              class="form-check-label upper-text"
              for="not_paid"
              >a pagar</label
            >
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
              class="form-check-label upper-text"
              for="not_paid"
              >a receber</label
            >
          </div>
        </div>
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center"
        >
          <LabelRequiredField label="NA CONTA:" />
        </div>
        <div
          class="col-xl-4 col-lg-3 col-md-7 col-sm-9 col-12 input-form-required"
        >
          <vs-select autocomplete style="width: 100%" v-model="account_id">
            <vs-select-item
              v-for="account in finance_configuration_account"
              :key="account.id"
              :value="account.id"
              :text="
                account.finance_configuration_grouping_description
                  ? `${account.finance_configuration_grouping_description} / ${account.account_nickname}`
                  : `${account.account_nickname}`
              "
            />
          </vs-select>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 text-right">
          <v-btn
            v-if="permission('write', 'financial_account')"
            class="btn-two-add"
            @click="handleIdModalCreate('finance_configuration_account')"
            ><i class="fas fa-plus mr-2"></i> NOVA CONTA</v-btn
          >
        </div>
      </div>

      <div class="content-card row m-0">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
          <label v-if="type == 'not_paid'">VENCE EM:</label>
          <label
            v-if="
              type != 'not_paid' &&
              (is_paid || type == 'paid') &&
              finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'
            "
            >PAGO EM:</label
          >
          <label
            v-if="
              type != 'not_paid' &&
              (is_paid || type == 'paid') &&
              finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'
            "
            >RECEBIDA EM:</label
          >
        </div>
        <div
          v-if="type == 'not_paid'"
          class="col-xl-2 col-lg-3 col-md-3 col-sm-5 col-12"
        >
          <input type="date" class="form-control" v-model="due_date" />
        </div>
        <div
          v-if="type == 'not_paid'"
          class="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-12"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="is_paid"
              id="is_paid"
            />
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'"
              class="form-check-label upper-text"
              for="is_paid"
            >
              Foi paga?
            </label>
            <label
              v-if="finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'"
              class="form-check-label upper-text"
              for="is_paid"
            >
              Recebida?
            </label>
          </div>
        </div>
        <div
          v-if="type == 'not_paid'"
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12"
        >
          <label
            class="upper-text"
            style="width: 100%"
            v-if="
              type == 'not_paid' &&
              is_paid &&
              finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'
            "
          >
            Paga em:
          </label>
          <label
            class="upper-text"
            style="width: 100%"
            v-if="
              type == 'not_paid' &&
              is_paid &&
              finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER'
            "
          >
            Recebida em:
          </label>
        </div>
        <div
          class="col-xl-2 col-lg-3 col-md-3 col-sm-5 col-12"
          v-if="is_paid || type == 'paid'"
        >
          <input type="date" class="form-control" v-model="paid_in_date" />
        </div>
      </div>

      <div
        class="content-card row m-0"
        v-if="type == 'not_paid' && !enable_resident"
      >
        <div
          v-if="type == 'not_paid' && !enable_resident"
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12"
        >
          <label class="upper-text">Repetir: </label>
        </div>
        <div
          v-if="type == 'not_paid' && !enable_resident"
          class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12"
        >
          <v-btn
            small
            :class="[repeat == 'NAO_SE_REPETE' && 'v-dark']"
            class="submenu-finacial"
            @click="handleClickRepeat('NAO_SE_REPETE')"
            ><i class="fas fa-file mr-2"></i>NÃO SE REPETE</v-btn
          >
          <v-btn
            small
            class="submenu-finacial"
            :class="[repeat == 'MAIS_DE_UMA_VEZ' && 'v-dark']"
            @click="handleClickRepeat('MAIS_DE_UMA_VEZ')"
            ><i class="fas fa-copy mr-2"></i>MAIS DE UMA VEZ</v-btn
          >
          <v-btn
            small
            class="submenu-finacial"
            :class="[repeat == 'SEMPRE' && 'v-dark']"
            @click="handleClickRepeat('SEMPRE')"
            ><i class="fas fa-sync mr-2"></i>SEMPRE</v-btn
          >
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
          v-if="
            type == 'not_paid' &&
            (repeat == 'MAIS_DE_UMA_VEZ' || repeat == 'SEMPRE')
          "
        >
          <div class="row">
            <div class="col-xl-2 col-lg-4 col-md-4 col-sm-3 col-12">
              <label class="upper-text">Periodicidade: </label>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-8 col-sm-6 col-12">
              <select class="form-control" v-model="periodicity">
                <option value="">SELECONE...</option>
                <option value="SEMANAL">SEMANAL</option>
                <option value="QUINZENAL">QUINZENAL</option>
                <option value="MENSAL">MENSAL</option>
                <option value="BIMESTRAL">BIMESTRAL</option>
                <option value="TRIMESTRAL">TRIMESTRAL</option>
                <option value="SEMESTRAL">SEMESTRAL</option>
                <option value="ANUAL">ANUAL</option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-if="type == 'not_paid' && repeat == 'MAIS_DE_UMA_VEZ'"
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
        >
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-3 col-12">
              <label>QUANTAS VEZES:</label>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-7 col-sm-6 col-12">
              <div class="input-group">
                <div
                  class="input-group-pprend d-flex align-items-center justify-content-center pl-2 pr-2 border"
                >
                  Por
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="how_many_times"
                />
                <div
                  class="input-group-pprend d-flex align-items-center justify-content-center pl-2 pr-2 border"
                >
                  vezes
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Closure
        v-if="
          finance_launch_bills_to_pay_type == 'CONTAS_A_RECEBER' &&
          enable_resident &&
          resident_id &&
          finance_client_id
        "
        :finance_client_id="finance_client_id"
        :resident_id="resident_id"
        :finance_client="finance_client"
        :finance_configuration_payment_methods="
          finance_configuration_payment_methods
        "
        :finance_configuration_category="finance_configuration_category"
        :finance_configuration_profit_cost_center="
          finance_configuration_profit_cost_center
        "
        :finance_configuration_tag="finance_configuration_tag"
        :cost_types="cost_types"
        :cost_appropriations="cost_appropriations"
        @search="handleSearchClosure"
        @items="handleItemsClosure"
      />

      <div
        class="content-card"
        v-show="!enable_resident"
        v-for="(item, key) in items"
        :key="key"
      >
        <div class="row m-0">
          <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-12">
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 input-form-required"
              >
                <input
                  placeholder="Descrição*"
                  type="text"
                  class="form-control"
                  v-model="item.description"
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12">
                <select
                  v-model="item.spent_or_gain"
                  class="form-control"
                  @change="handleSpentOrGainItem(key)"
                >
                  <option value="DEBITO">DÉBITO</option>
                  <option value="CREDITO">CRÉDITO</option>
                </select>
              </div>
              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 input-form-required"
              >
                <input
                  placeholder="Valor*"
                  type="text"
                  :class="[
                    'form-control',
                    item.spent_or_gain == 'DEBITO' && 'c-danger',
                    item.spent_or_gain == 'CREDITO' && 'c-success',
                  ]"
                  v-model="item.value"
                  :id="`value-${key}`"
                  @input="handleInputValue($event.target.value, key)"
                />
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div
                    class="col-xl-8 col-lg-9 col-md-8 col-sm-9 col-12 vue-treeselect-required"
                  >
                    <treeselect
                      :options="finance_configuration_category"
                      placeholder="SELECIONE..."
                      v-model="item.finance_configuration_category_id"
                      noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-3 col-md-4 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_category')"
                      class="btn-add"
                      @click="
                        handleIdModalCreate(
                          'finance_configuration_category',
                          key
                        )
                      "
                      ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div class="col-xl-8 col-lg-9 col-md-8 col-sm-9 col-12">
                    <vs-select
                      autocomplete
                      style="width: 100%"
                      v-model="item.finance_configuration_profit_cost_center_id"
                    >
                      <vs-select-item
                        value=""
                        text="Centro de custo/lucro..."
                      />
                      <vs-select-item
                        v-for="profit_cost_center in finance_configuration_profit_cost_center"
                        :key="profit_cost_center.id"
                        :value="profit_cost_center.id"
                        :text="profit_cost_center.description"
                      />
                    </vs-select>
                  </div>
                  <div
                    class="col-xl-4 col-lg-3 col-md-4 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_profit_cost_center')"
                      class="btn-add"
                      @click="
                        handleIdModalCreate(
                          'finance_configuration_profit_cost_center',
                          key
                        )
                      "
                      ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
                    >
                  </div>
                </div>
              </div>
              <div
                v-show="item.spent_or_gain == 'DEBITO'"
                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div class="col-xl-8 col-lg-9 col-md-8 col-sm-9 col-12">
                    <vs-select
                      autocomplete
                      style="width: 100%"
                      v-model="item.provider_id"
                    >
                      <vs-select-item value="" text="Fornecedor..." />
                      <vs-select-item
                        v-for="provider in providers"
                        :key="provider.id"
                        :value="provider.id"
                        :text="provider.company_name"
                      />
                    </vs-select>
                  </div>
                  <div
                    class="col-xl-4 col-lg-3 col-md-4 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_provider')"
                      class="btn-add"
                      @click="handleIdModalCreate('provider', key)"
                      ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
                    >
                  </div>
                </div>
              </div>
              <div
                v-show="item.spent_or_gain == 'CREDITO'"
                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div class="col-xl-8 col-lg-9 col-md-8 col-sm-9 col-12">
                    <vs-select
                      autocomplete
                      style="width: 100%"
                      v-model="item.finance_client_id"
                    >
                      <vs-select-item value="" text="Cliente..." />
                      <vs-select-item
                        v-for="client in finance_client"
                        :key="client.id"
                        :value="client.id"
                        :text="`${client.resident_id ? '(RESIDENTE) - ' : ''}${
                          client.name
                        }`"
                      />
                    </vs-select>
                  </div>
                  <div
                    class="col-xl-4 col-lg-3 col-md-4 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_client')"
                      class="btn-add"
                      @click="handleIdModalCreate('finance_client', key)"
                      ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div class="col-xl-8 col-lg-9 col-md-8 col-sm-9 col-12">
                    <vs-select
                      autocomplete
                      style="width: 100%"
                      v-model="item.finance_configuration_payment_methods_id"
                    >
                      <vs-select-item value="" text="Forma de pagamento..." />
                      <vs-select-item
                        v-for="payment_method in finance_configuration_payment_methods"
                        :key="payment_method.id"
                        :value="payment_method.id"
                        :text="payment_method.description"
                      />
                    </vs-select>
                  </div>
                  <div
                    class="col-xl-4 col-lg-3 col-md-4 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_payment_methods')"
                      class="btn-add"
                      @click="
                        handleIdModalCreate(
                          'finance_configuration_payment_methods',
                          key
                        )
                      "
                      ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
              >
                <div class="row">
                  <div class="col-xl-8 col-lg-10 col-md-10 col-sm-9 col-12">
                    <v-select
                      hide-details
                      v-model="item.finance_configuration_tag_ids"
                      :items="finance_configuration_tag"
                      chips
                      label="Tags"
                      multiple
                      solo
                      item-text="description"
                      item-value="id"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-2 col-md-2 col-sm-3 col-12 text-right"
                  >
                    <v-btn
                      v-if="permission('write', 'financial_tags')"
                      class="btn-add"
                      @click="
                        handleIdModalCreate('finance_configuration_tag', key)
                      "
                      ><i class="fas fa-plus mr-2"></i> NOVA
                    </v-btn>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                <vs-select
                  autocomplete
                  style="width: 100%"
                  v-model="item.cost_type"
                >
                  <vs-select-item value="" text="Tipo de custo..." />
                  <vs-select-item
                    v-for="cost_type in cost_types"
                    :key="cost_type.value"
                    :value="cost_type.value"
                    :text="cost_type.description"
                  />
                </vs-select>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                <vs-select
                  autocomplete
                  style="width: 100%"
                  v-model="item.cost_appropriation"
                >
                  <vs-select-item value="" text="Apropriação de custo..." />
                  <vs-select-item
                    v-for="cost_appropriation in cost_appropriations"
                    :key="cost_appropriation.value"
                    :value="cost_appropriation.value"
                    :text="cost_appropriation.description"
                  />
                </vs-select>
              </div>
            </div>
          </div>
          <div
            class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 d-flex justify-content-end align-items-center"
            v-if="items.length > 1"
          >
            <confirmation-dialog
              v-if="items.length > 1"
              headerClass="modal-header-i"
              small
              message-title="REMOVER?"
              :message-body="`Deseja realmente remover o item?`"
              open-class="btn-delete"
              open-left-icon="fa-trash"
              open-text=""
              @yes="handleRemoveItem(key)"
            />
          </div>
        </div>
      </div>

      <div v-show="!enable_resident" class="content-card p-3 text-right">
        <v-btn class="btn-two-add" @click="handleAddItem"
          ><i class="fas fa-plus mr-2"></i> ADICIONAR OUTRO ITEM</v-btn
        >
      </div>
    </div>

    <div class="content-card">
      <b-modal
        size="md"
        no-close-on-backdrop
        hide-footer
        id="attachment"
        title="Adicionar documento"
      >
        <Attachment
          @success="handleSuccessAttachment"
          @cancel="$bvModal.hide('attachment')"
        />
      </b-modal>
      <div class="row m-0">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center"
        >
          <label class="upper-text">Anexos</label>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <div class="row">
            <div
              class="col-xl-4 col-lg-6 col-md-10 col-sm-12 col-12"
              v-for="item in attachment"
              :key="item.id"
            >
              <div
                class="border p-2 d-flex align-items-center justify-content-between"
              >
                <p class="m-0 text-fourteen">{{ item.name }}</p>
                <confirmation-dialog
                  small
                  headerClass="modal-header-i"
                  message-title="REMOVER?"
                  :message-body="`Deseja realmente remover o anexo?`"
                  open-class="btn-delete"
                  open-left-icon="fa-times"
                  @yes="handleRemoveAttachment(item)"
                />
              </div>
            </div>
          </div>
          <v-btn
            small
            class="btn-two-add text-right"
            @click="handleModalAddAttachment"
            ><i class="fas fa-copy mr-2"></i> ADICIONAR ARQUIVO</v-btn
          >
        </div>
      </div>
    </div>

    <div class="content-card">
      <div class="row m-0">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center"
        >
          <label class="upper-text">Opções</label>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12">
              <label class="mb-0">Observação</label>
              <ChromeSpeechToTextTextarea rows="7" v-model="note" />
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <label class="mb-0">Competência</label>
              <input type="date" class="form-control" v-model="competence" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <label class="mb-0">Tipo de documento</label>
              <div class="row">
                <div class="col-xl-9 col-lg-8 col-md-9 col-sm-9 col-12 pt-0">
                  <vs-select
                    autocomplete
                    style="width: 100%"
                    v-model="finance_configuration_document_types_id"
                  >
                    <vs-select-item
                      v-for="document_type in finance_configuration_document_types"
                      :key="document_type.id"
                      :value="document_type.id"
                      :text="document_type.description"
                    />
                  </vs-select>
                </div>
                <div
                  class="col-xl-3 col-lg-4 col-md-3 col-sm-3 col-12 pt-0 text-right"
                >
                  <v-btn
                    v-if="permission('write', 'financial_document_types')"
                    class="btn-add"
                    @click="
                      handleIdModalCreate(
                        'finance_configuration_document_types'
                      )
                    "
                    ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
                  >
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
              <label class="mb-0">Número do documento</label>
              <input
                type="text"
                class="form-control"
                v-model="document_number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-card">
      <div class="row m-0">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12"></div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <WarningRequiredFields />
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12"></div>
        <div
          class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 d-flex justify-content-between"
        >
          <confirmation-dialog
            headerClass="modal-header-red"
            message-title="CANCELAR?"
            :message-body="`Deseja realmente CANCELAR o registro de ${
              finance_launch_bills_to_pay_type == 'CONTAS_A_PAGAR'
                ? 'DÉBITO'
                : 'CRÉDITO'
            }?`"
            open-class="btn-cancel"
            open-text="CANCELAR"
            yesClass="btn-delete worksansr"
            @yes="handleBack"
          />
          <v-btn :disabled="loading" @click="create" class="ml-2 btn-save">
            <i class="fas fa-check mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import ConfirmationDialog from "../../Components/ConfirmationDialog";

import ChromeSpeechToTextTextarea from "../../Components/ChromeSpeechToTextTextarea";

import LabelRequiredField from "../../Components/LabelRequiredField";

import WarningRequiredFields from "../../Components/WarningRequiredFields";

import Treeselect from "@riophae/vue-treeselect";

import Attachment from "./SpentGain/Attachment";

import ModalIdCreate from "./SpentGain/ModalIdCreate";

import NewAccount from "../Configuration/Accounts/Create";
import NewCatgegory from "../Configuration/Categories/Create";
import NewProfitCostCenter from "../Configuration/CostProfitCenter/Create";
import NewProvider from "../Provider/NewProvider";
import NewClient from "../Client/NewFinanceClient";

import Closure from "./SpentGain/Closure";

import moment from "moment";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../lib/format";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import permission from "../../../lib/permission";

import {
  getStatic,
  getRestHomeSelectedFinancialAccount,
} from "../../../lib/functions";

export default {
  name: "Spent",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    WarningRequiredFields,
    Treeselect,
    Attachment,
    ModalIdCreate,
    NewAccount,
    NewCatgegory,
    NewProfitCostCenter,
    NewProvider,
    NewClient,
    Closure,
  },

  props: {
    finance_launch_bills_to_pay_type: String,
  },

  data() {
    return {
      enable_resident: false,

      finance_client_id: null,
      resident_id: null,
      residents: [],

      type: "paid",
      account_id: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,
      due_date: moment().format("YYYY-MM-DD"),
      paid_in_date: moment().format("YYYY-MM-DD"),
      periodicity: "MENSAL",
      how_many_times: "",
      items: [],
      itemsFinance: [],
      note: "",
      competence: "",
      finance_configuration_document_types_id: "",
      document_number: "",
      cost_types: [
        { value: "FIXO", description: "FIXO" },
        { value: "VARIAVEL", description: "VARIÁVEL" },
      ],
      cost_appropriations: [
        { value: "DIRETO", description: "DIRETO" },
        { value: "INDIRETO", description: "INDIRETO" },
      ],
      finance_configuration_account: [],
      finance_configuration_category: [],
      finance_configuration_profit_cost_center: [],
      providers: [],
      finance_client: [],
      finance_configuration_payment_methods: [],
      finance_configuration_tag: [],
      finance_configuration_document_types: [],
      banks: [],
      attachment: [],
      errors: [],
      itemKey: "",
      loading: false,
      idCreate: "",
      titleModalIdCreate: "",
      listItemKey: 0,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    permission,

    handleChangeEnableResident() {
      this.repeat = "NAO_SE_REPETE";
      this.periodicity = "MENSAL";
      this.how_many_times = "";
      this.finance_client_id = null;
      this.resident_id = null;
      this.itemsFinance = [];
    },

    handleChangeResidentId(id) {
      let { residents } = this;

      let resident = residents.find((res) => res.id == id);

      if (resident) {
        this.resident_id = resident.resident_id;
      } else {
        this.resident_id = null;
      }
    },

    handleSearchClosure() {
      this.itemsFinance = [];
    },

    handleItemsClosure(items) {
      if (items.length > 0) {
        let itemsFinance = [];
        for (let item of items) {
          let {
            id,
            type,
            description,
            value,
            finance_configuration_category_id,
            finance_configuration_profit_cost_center_id,
            provider_id,
            finance_client_id,
            finance_configuration_payment_methods_id,
            finance_configuration_tag_ids,
            cost_type,
            cost_appropriation,
            spent_or_gain,
          } = item;

          itemsFinance.push({
            id,
            type,
            description,
            value,
            finance_configuration_category_id,
            finance_configuration_profit_cost_center_id,
            provider_id,
            finance_client_id,
            finance_configuration_payment_methods_id,
            finance_configuration_tag_ids,
            cost_type,
            cost_appropriation,
            spent_or_gain,
          });
        }

        this.itemsFinance = itemsFinance;
      } else {
        this.itemsFinance = [];
      }
    },

    async handleSuccessAccount(id) {
      this.$bvModal.hide("idCreate");
      await this.financeConfigurationAccount();
      this.account_id = id;
    },

    async handleSuccessCategory(id) {
      this.$bvModal.hide("idCreate");
      await this.financeConfigurationCategory();
      this.items[this.listItemKey].finance_configuration_category_id = id;
    },

    async handleSuccessProfitCostCenter(id) {
      this.$bvModal.hide("idCreate");
      await this.financeConfigurationProfitCostCenter();
      this.items[this.listItemKey].finance_configuration_profit_cost_center_id =
        id;
    },

    async handleSuccessProvider(id) {
      this.$bvModal.hide("new_provider");
      await this.provider();
      this.items[this.listItemKey].provider_id = id;
    },

    async handleSuccessClient({ id }) {
      this.$bvModal.hide("new_finance_client");
      await this.financeClient();
      this.items[this.listItemKey].finance_client_id = id;
    },

    handleIdModalCreate(id, listItemKey = null) {
      if (id) {
        this.listItemKey = listItemKey;

        let titleModalIdCreate =
          {
            finance_configuration_account: "NOVA CONTA",
            finance_configuration_category: "NOVA CATEGORIA",
            finance_configuration_profit_cost_center:
              "NOVO CENTRO DE CUSTO/LUCRO",
            provider: "NOVO FORNECEDOR",
            finance_client: "NOVO CLIENTE",
            finance_configuration_payment_methods: "NOVA FORMA DE PAGAMENTO",
            finance_configuration_tag: "NOVA TAG",
            finance_configuration_document_types: "NOVO TIPO DE DOCUMENTO",
          }[id] || "";

        this.titleModalIdCreate = titleModalIdCreate;
        this.idCreate = id;
        if (id == "provider") {
          this.$bvModal.show("new_provider");
        } else if (id == "finance_client") {
          this.$bvModal.show("new_finance_client");
        } else {
          this.$bvModal.show("idCreate");
        }
      }
    },

    async handleSuccessIdCreate({ type, id }) {
      this.$bvModal.hide("idCreate");

      if (type == "provider") {
        await this.provider();
        this.items[this.listItemKey].provider_id = id;
      }

      if (type == "finance_client") {
        await this.financeClient();
        this.items[this.listItemKey].finance_client_id = id;
      }

      if (type == "finance_configuration_payment_methods") {
        await this.financeConfigurationPaymentMethods();
        this.items[this.listItemKey].finance_configuration_payment_methods_id =
          id;
      }

      if (type == "finance_configuration_profit_cost_center") {
        await this.financeConfigurationProfitCostCenter();
        this.items[
          this.listItemKey
        ].finance_configuration_profit_cost_center_id = id;
      }

      if (type == "finance_configuration_tag") {
        await this.financeConfigurationTag();
        this.items[this.listItemKey].finance_configuration_tag_ids = id;
      }

      if (type == "finance_configuration_document_types") {
        await this.financeConfigurationDocumentTypes();
        this.finance_configuration_document_types_id = id;
      }
    },

    handleModalAddAttachment() {
      this.$bvModal.show("attachment");
    },

    handleSuccessAttachment(attachment) {
      this.$bvModal.hide("attachment");
      this.attachment.push(attachment);
    },

    handleRemoveAttachment({ id }) {
      this.attachment.map((item, key) => {
        if (item.id == id) {
          this.attachment.splice(key, 1);
        }
      });
    },

    handleBack() {
      this.$emit("cancel");
    },

    handleClickRepeat(repeat) {
      this.repeat = repeat;
    },

    handleInputValue(value, key) {
      if (this.items[key].spent_or_gain == "DEBITO") {
        this.items[key].value = formatValueNegativeOnKeyUp(value);
      } else {
        this.items[key].value = formatValueOnKeyUp(value);
      }
    },

    handleInputType(event) {
      let { value } = event.target;

      if (value == "paid") {
        this.is_paid = true;
      } else {
        this.is_paid = false;
      }

      this.repeat = "NAO_SE_REPETE";
    },

    handleAddItem() {
      let { items } = this;

      let lastItem = items[items.length - 1];

      let {
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
        spent_or_gain,
      } = lastItem;

      let item = {
        description: "",
        value: "",
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
        spent_or_gain,
      };

      this.items = [...items, item];
    },

    handleRemoveItem(key) {
      this.items.splice(key, 1);
    },

    handleSpentOrGainItem(key) {
      this.items[key].provider_id = "";
      this.items[key].finance_client_id = "";
      this.handleInputValue(this.items[key].value, key);
    },

    async retrieve() {
      let { finance_launch_bills_to_pay_type } = this;

      let item = {
        description: "",
        value: "",
        finance_configuration_category_id: "",
        finance_configuration_profit_cost_center_id: "",
        provider_id: "",
        finance_client_id: "",
        finance_configuration_payment_methods_id: "",
        finance_configuration_tag_ids: "",
        cost_type: "",
        cost_appropriation: "",
        spent_or_gain:
          finance_launch_bills_to_pay_type == "CONTAS_A_PAGAR"
            ? "DEBITO"
            : "CREDITO",
      };

      this.items.push(item);

      await this.financeConfigurationAccount();
      await this.financeConfigurationCategory();
      await this.financeConfigurationProfitCostCenter();
      await this.provider();
      await this.financeClient();
      await this.financeConfigurationPaymentMethods();
      await this.financeConfigurationTag();
      await this.financeConfigurationDocumentTypes();

      try {
        this.banks = (await getStatic("/banks", true)).banks;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async financeConfigurationAccount() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/account-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        let finance_configuration_account = [];
        for (let account of data) {
          finance_configuration_account.push(account);
          if (account.default == 1) {
            this.account_id = account.id;
          }
        }

        this.finance_configuration_account = finance_configuration_account;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationCategory() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let { finance_launch_bills_to_pay_type } = this;

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params: {
              rest_home_id_selected_financial_account,
              classification: finance_launch_bills_to_pay_type,
            },
          }
        );

        const { data } = response.data;

        let finance_configuration_category = [];
        for (let category of data) {
          finance_configuration_category.push(category);
          if (category.default == 1) {
            this.items[0].finance_configuration_category_id = category.id;
          }
        }

        this.finance_configuration_category = finance_configuration_category;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationProfitCostCenter() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },

    async provider() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        const params = { rest_home_id_selected_financial_account, active: 1 };

        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },

    async financeClient() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/financial/client-actives", {
          params,
        });

        const { data } = response.data;

        let residents = [];
        for (let client of data) {
          if (client.resident_id) {
            residents.push(client);
          }
        }

        this.residents = residents;
        this.finance_client = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationPaymentMethods() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationTag() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_tag = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationDocumentTypes() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        const {
          type,
          account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          itemsFinance,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
          finance_launch_bills_to_pay_type,
          finance_client_id,
          enable_resident,
        } = this;

        let params = {
          type,
          account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          itemsFinance,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
          finance_launch_bills_to_pay_type,
          finance_client_id,
          enable_resident,
        };

        const response = await api.post(
          "/rest-home/financial/launch/pay",
          params
        );

        const { error, errors, message, itemKey, id } = response.data;

        if (!error) {
          if (id) {
            this.createAttachment(id, message);
          } else {
            toast(message, "success");
            this.loading = false;
            this.$emit("success");
          }

          this.itemKey = "";
          this.errors = [];
        } else {
          this.itemKey = itemKey;
          this.errors = errors;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async createAttachment(id, message) {
      try {
        this.loading = true;

        let { attachment } = this;

        for (let item of attachment) {
          const formData = new FormData();
          formData.append("finance_launch_bills_to_pay_installments_id", id);
          formData.append("attachment", item.attachment, item.attachment.name);
          formData.append("type", item.attachment.type);
          await api.post("/rest-home/financial/launch/attachment", formData);
        }

        toast(message, "success");
        this.$emit("success");

        this.loading = false;
      } catch (error) {
        this.$emit("success");
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.content-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 6px;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 5px;
}
</style>